import React, { useState } from 'react';
import { postToHub } from '../network/actions';
import { InputText } from 'primereact/inputtext';

function MfaVerifyStep({ showTrustOption, onAuthenticated, onBack }) {
    const [totp, setTotp] = useState('');
    const [trustDevice, setTrust] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (totp === null || totp.length !== 6) {
            setError('Please enter a valid 6-digit code.');
            return;
        }
        setLoading(true);
        setError('');

        try {
            const payload = {
                totp: Number(totp),
                trustDevice,
            };

            const response = await postToHub('authentication/mfa/validate', payload);

            if (response && response.isAuthenticated) {
                onAuthenticated(response);
            } else {
                setError('Incorrect code. Please try again.');
            }
        } catch {
            setError('Verification failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col">
            <div className="mb-4">
                <h2 className="text-lg font-semibold text-gray-800">Two-factor authentication</h2>
                <p className="text-xs text-gray-500">Enter the code from your authenticator app</p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4 text-xs text-blue-800">
                Enter the 6-digit code from your authenticator app.
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                <div>
                    <label htmlFor="totp-verify" className="block text-xs font-medium text-gray-600 mb-1">
                        Verification code
                    </label>
                    <InputText
                        id="totp-verify"
                        value={totp}
                        onChange={(e) => {
                            setError('');
                            setTotp(e.target.value.replace(/\D/g, ''));
                        }}
                        maxLength={6}
                        autoComplete="off"
                        className="w-full text-center text-2xl"
                        autoFocus
                    />
                </div>

                {showTrustOption && (
                    <label className="flex items-center gap-2 cursor-pointer select-none">
                        <input
                            type="checkbox"
                            id="trust-device"
                            checked={trustDevice}
                            onChange={(e) => setTrust(e.target.checked)}
                            className="w-4 h-4 text-blue-600 rounded"
                        />
                        <span className="text-sm text-gray-600">
                            Trust this device
                        </span>
                    </label>
                )}

                {error &&
                    <div className="text-red-700">
                        {error}
                    </div>
                }

                <button
                    type="submit"
                    disabled={loading || totp.length !== 6}
                    className="w-full bg-blue-800 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold py-2.5 rounded-lg transition-colors"
                >
                    {loading ? 'Verifying…' : 'Verify'}
                </button>

                <button
                    type="button"
                    onClick={onBack}
                    className="text-sm text-gray-500 hover:text-gray-700 text-center"
                >
                    ← Back to sign in
                </button>
            </form>
        </div>
    );
}

export default MfaVerifyStep;
